import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { OpportunityService } from '../services/opportunity.service';
import { Path } from '../constants';
import { OpportunityStatusValue } from '../models/opportunity.model';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * Guard that prevents navigation to the edit opportunity route
 * when the opportunity status is 'accepted'.
 * Redirects to the opportunities list if blocked.
 */
export const opportunityEditGuard: CanActivateFn = route => {
  const opportunityService = inject(OpportunityService);
  const router = inject(Router);

  const id = Number(route.paramMap.get('id'));

  if (!id || isNaN(id)) {
    router.navigate([`/${Path.OPPORTUNITIES}`]);
    return of(false);
  }

  return opportunityService.getOpportunity(id).pipe(
    map(opportunity => {
      if (opportunity.status.value === OpportunityStatusValue.ACCEPTED) {
        router.navigate([`/${Path.OPPORTUNITIES}`]);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate([`/${Path.OPPORTUNITIES}`]);
      return of(false);
    })
  );
};
